import { useState } from "react";
import { api } from "@/data/api";
import { npmApiErrorMessage } from "@/data/npmState";
import { useAsync } from "@/hooks/useAsync";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Troca o Server de um Environment: preview → confirmação explícita.
// Somente metadado; nenhum container é movido ou adotado.
export function EnvironmentServerDialog({ projectId, environment, onClose, onChanged }) {
  const servers = useAsync(() => (environment ? api.listServersRaw() : Promise.resolve([])), [environment?.id]);
  const [target, setTarget] = useState("");
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!environment) return null;
  const body = (confirm) => ({ server_id: target, expected_current_server_id: environment.server_id, confirm });
  const review = async () => {
    setError(null);
    try {
      setPreview((await api.changeEnvironmentServer(projectId, environment.id, body(false))).preview);
    } catch (e) {
      setError(npmApiErrorMessage(e));
    }
  };
  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.changeEnvironmentServer(projectId, environment.id, body(true));
      onChanged();
      onClose();
    } catch (e) {
      setError(npmApiErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return <Dialog open onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-lg border-line bg-popover">
      <DialogHeader>
        <DialogTitle>Trocar servidor · {environment.name}</DialogTitle>
        <DialogDescription>Altera apenas o servidor do Environment (auditado). Nenhum container é movido e nenhum serviço é adotado automaticamente.</DialogDescription>
      </DialogHeader>
      <p className="text-sm">Atual: <span className="font-mono">{environment.server || "—"}</span> ({environment.server_status || "—"})</p>
      <select value={target} onChange={(e) => { setTarget(e.target.value); setPreview(null); }} className="rounded border border-line bg-background px-2 py-1.5 text-sm" data-testid="env-server-select">
        <option value="">Escolha o servidor…</option>
        {(servers.data || []).filter((s) => s.id !== environment.server_id).map((s) => <option key={s.id} value={s.id}>{`${s.hostname} (${s.connection_status})`}</option>)}
      </select>
      {preview && <div className="rounded-lg border border-line p-3 text-sm" data-testid="env-server-preview">
        <p>{preview.from || "—"} → <span className="font-medium">{preview.to}</span> ({preview.target_status})</p>
        <p className="text-xs text-muted-foreground">{preview.note}</p>
      </div>}
      {error && <p role="alert" className="rounded-lg border border-err/30 bg-err/10 px-3 py-2 text-sm text-err">{error}</p>}
      <div className="flex justify-end gap-2">
        <Button size="sm" variant="outline" onClick={onClose}>Cancelar</Button>
        {!preview ? <Button size="sm" disabled={!target} onClick={review}>Revisar</Button>
          : <Button size="sm" disabled={busy} onClick={confirm} data-testid="env-server-confirm">{busy ? "Aplicando…" : "Confirmar troca"}</Button>}
      </div>
    </DialogContent>
  </Dialog>;
}
